import GSAP from 'gsap';
import Page from '@averyano/core/src/classes/Page';
import ScrollTrigger from 'gsap/ScrollTrigger';

export default class ProductsPage extends Page {
	constructor(el) {
		super({
			element: el,
			elements: {
				wrapper: '.products__wrapper',
			},
		});

		this.id = 'products';
		this.isCreated = false;
	}

	create() {
		if (this.template !== this.id) return;
		if (!this.isReady) super.createComponent();
		if (!this.isCreated) {
			this.components = {};
			this.isCreated = true;
		}

		super.create();
		this.addEventListeners();
	}

	show() {
		GSAP.to(this.element, {
			autoAlpha: 1,
			duration: 1.5,
			ease: 'power2.out',
		});

		window.scrollTo(0, 0);
	}

	hide() {
		return new Promise((resolve) => {
			ScrollTrigger.getAll().forEach((t) => t.kill());
			GSAP.to(this.element, {
				autoAlpha: 0,
				duration: 1.5,
				ease: 'expo.out',
				onComplete: resolve,
			});
		});
	}

	update() {}

	onResize() {}

	addEventListeners() {}

	removeEventListeners() {}

	destroy() {
		this.scrollTrigger?.kill();
		super.destroy();
	}
}
